"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Bar;
var _react = _interopRequireWildcard(require("react"));
var _bar = require("cccisd-nivo/bar");
var _cccisdColorPicker = require("cccisd-color-picker");
var _Settings = _interopRequireWildcard(require("./Settings"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function Bar(_ref) {
  var _settings$markers$;
  var data = _ref.data,
    settings = _ref.settings;
  var _useState = (0, _react.useState)(settings.maxValue || 'auto'),
    _useState2 = _slicedToArray(_useState, 2),
    maxValueFromSettings = _useState2[0],
    setMaxValueFromSettings = _useState2[1];
  var _useState3 = (0, _react.useState)(10),
    _useState4 = _slicedToArray(_useState3, 2),
    maxValueFromData = _useState4[0],
    setMaxValueFromData = _useState4[1];
  var _useState5 = (0, _react.useState)('auto'),
    _useState6 = _slicedToArray(_useState5, 2),
    maxValueForChart = _useState6[0],
    setMaxValueForChart = _useState6[1];
  (0, _react.useEffect)(function () {
    var max = data.map(function (d) {
      return Object.entries(d).filter(function (_ref2) {
        var _settings$keys;
        var _ref3 = _slicedToArray(_ref2, 2),
          k = _ref3[0],
          v = _ref3[1];
        return settings === null || settings === void 0 ? void 0 : (_settings$keys = settings.keys) === null || _settings$keys === void 0 ? void 0 : _settings$keys.includes(k);
      }).reduce(function (a, c) {
        return a >= Number(c[1]) ? a : Number(c[1]);
      }, 0);
    }).reduce(function (a, c) {
      return a >= c ? a : c;
    }, 0);
    setMaxValueFromData(max);
  }, [settings.keys, data]);
  (0, _react.useEffect)(function () {
    setMaxValueFromSettings(settings.maxValue || 'auto');
  }, [settings.maxValue]);
  (0, _react.useEffect)(function () {
    if (maxValueFromSettings === 'auto' || !maxValueFromSettings) {
      if (maxValueFromData > 10) {
        setMaxValueForChart('auto');
      } else {
        setMaxValueForChart(10);
      }
    } else if (maxValueFromSettings > 10) {
      setMaxValueForChart(maxValueFromSettings);
    } else if (maxValueFromSettings <= 10) {
      setMaxValueForChart(10);
    }
  }, [maxValueFromSettings, maxValueFromData]);
  if (typeof settings.colors === 'string') {
    if (settings.colors === 'custom') {
      settings.colors = (0, _cccisdColorPicker.getColor)(settings.customColors);
    } else {
      settings.colors = {
        scheme: settings.colors
      };
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_bar.ResponsiveBar, _extends({
    data: data
  }, settings, settings.showLegend ? {} : {
    legends: []
  }, (settings === null || settings === void 0 ? void 0 : (_settings$markers$ = settings.markers[0]) === null || _settings$markers$ === void 0 ? void 0 : _settings$markers$.value) === '' ? {
    markers: []
  } : {}, {
    maxValue: maxValueForChart
  }));
}
Bar.Settings = function (_ref4) {
  var field = _ref4.field,
    form = _ref4.form,
    children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
    field: field,
    form: form
  }, children);
};
Bar.initialValues = _Settings.initialValues;